/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetDeliveryAreas200ResponseInnerGeometry } from './GetDeliveryAreas200ResponseInnerGeometry';
import {
    GetDeliveryAreas200ResponseInnerGeometryFromJSON,
    GetDeliveryAreas200ResponseInnerGeometryFromJSONTyped,
    GetDeliveryAreas200ResponseInnerGeometryToJSON,
    GetDeliveryAreas200ResponseInnerGeometryToJSONTyped,
} from './GetDeliveryAreas200ResponseInnerGeometry';
import type { GetDeliveryAreas200ResponseInnerType } from './GetDeliveryAreas200ResponseInnerType';
import {
    GetDeliveryAreas200ResponseInnerTypeFromJSON,
    GetDeliveryAreas200ResponseInnerTypeFromJSONTyped,
    GetDeliveryAreas200ResponseInnerTypeToJSON,
    GetDeliveryAreas200ResponseInnerTypeToJSONTyped,
} from './GetDeliveryAreas200ResponseInnerType';

/**
 * 
 * @export
 * @interface CreateDeliveryAreaRequest
 */
export interface CreateDeliveryAreaRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateDeliveryAreaRequest
     */
    name?: string;
    /**
     * 
     * @type {GetDeliveryAreas200ResponseInnerType}
     * @memberof CreateDeliveryAreaRequest
     */
    type: GetDeliveryAreas200ResponseInnerType;
    /**
     * 
     * @type {GetDeliveryAreas200ResponseInnerGeometry}
     * @memberof CreateDeliveryAreaRequest
     */
    geometry: GetDeliveryAreas200ResponseInnerGeometry;
    /**
     * 
     * @type {number}
     * @memberof CreateDeliveryAreaRequest
     */
    deliveryFee?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateDeliveryAreaRequest
     */
    deliveryExtraMinutes?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateDeliveryAreaRequest
     */
    minimumBasket?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDeliveryAreaRequest
     */
    enabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateDeliveryAreaRequest
     */
    position?: number;
}

/**
 * Check if a given object implements the CreateDeliveryAreaRequest interface.
 */
export function instanceOfCreateDeliveryAreaRequest(value: object): value is CreateDeliveryAreaRequest {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('geometry' in value) || value['geometry'] === undefined) return false;
    return true;
}

export function CreateDeliveryAreaRequestFromJSON(json: any): CreateDeliveryAreaRequest {
    return CreateDeliveryAreaRequestFromJSONTyped(json, false);
}

export function CreateDeliveryAreaRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDeliveryAreaRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'type': GetDeliveryAreas200ResponseInnerTypeFromJSON(json['type']),
        'geometry': GetDeliveryAreas200ResponseInnerGeometryFromJSON(json['geometry']),
        'deliveryFee': json['deliveryFee'] == null ? undefined : json['deliveryFee'],
        'deliveryExtraMinutes': json['deliveryExtraMinutes'] == null ? undefined : json['deliveryExtraMinutes'],
        'minimumBasket': json['minimumBasket'] == null ? undefined : json['minimumBasket'],
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
        'position': json['position'] == null ? undefined : json['position'],
    };
}

export function CreateDeliveryAreaRequestToJSON(json: any): CreateDeliveryAreaRequest {
    return CreateDeliveryAreaRequestToJSONTyped(json, false);
}

export function CreateDeliveryAreaRequestToJSONTyped(value?: CreateDeliveryAreaRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'type': GetDeliveryAreas200ResponseInnerTypeToJSON(value['type']),
        'geometry': GetDeliveryAreas200ResponseInnerGeometryToJSON(value['geometry']),
        'deliveryFee': value['deliveryFee'],
        'deliveryExtraMinutes': value['deliveryExtraMinutes'],
        'minimumBasket': value['minimumBasket'],
        'enabled': value['enabled'],
        'position': value['position'],
    };
}

